import { jsx as _jsx } from "react/jsx-runtime";
import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
const LandingPage = lazy(() => import('@/pages/landing/LandingPage'));
function ChunkLoader() {
    return (_jsx("div", { className: "flex min-h-svh items-center justify-center bg-neutral-50", children: _jsx("div", { className: "h-8 w-8 animate-spin rounded-full border-2 border-primary-200 border-t-primary-700" }) }));
}
export default function App() {
    return (_jsx(Suspense, { fallback: _jsx(ChunkLoader, {}), children: _jsx(Routes, { children: _jsx(Route, { path: "*", element: _jsx(LandingPage, {}) }) }) }));
}
//# sourceMappingURL=App.js.map